module.exports = "https://website-assets.prd.scentregroup.io/account/_next/static/media/disney-100-cvp-bg.9c747cab.png";